"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMe = void 0;
const store_1 = require("@app/store");
const useMe = () => {
    const me = (0, store_1.useRootSelector)((state) => state.me);
    return me;
};
exports.useMe = useMe;
